import services from '../services/services';

import {
  apiNames,
  apiOperatonIds,
} from 'constants/api/uiConfigApi';

export function sendStats(trackingData) {
  services.uiConfig(apiNames.USERACTION, apiOperatonIds.STATISTICS)(_=>_, {request:trackingData});
}